declare global {
  const CI_COMMIT_SHA: string | undefined;
  const BUILD_NUMBER: string | undefined;
}
/* eslint-disable no-underscore-dangle */
const SENTRY_DSN = window?.__marketplace_frontend_env__?.SENTRY_DSN;

export { SENTRY_DSN };
